
import * as React from 'react';
import { Text, Group, Line, Circle } from 'react-konva';
import {SubLayer} from './StrengLaegger'
class Potato_row extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isTransparent: false
        };
    }

   
    handleRowClick = (e) => {
        // Prevent default touch behavior  
        this.props.onToggle(this.props.nr, !this.state.isTransparent);            
        this.setState(prevState => ({
            isTransparent: !prevState.isTransparent
        }));
         
    }

    render() {

        let height = 300;
        let topWidth = 200;
        let delta = (this.props.width - topWidth) / 2;
        let potatoRad = 50;
        let potato_y = -(height / 2 + potatoRad)
        const opacity = this.state.isTransparent ? 0.3 : 1;

        return (
            <Group
            x={this.props.x}
            y={this.props.y}
            onClick={this.handleRowClick}
            onTouchStart={this.handleRowClick}
     
            >
            <Line
                x={0}
                y={0}
                points={[0, 0,
                    delta, -height,
                    this.props.width - delta, -height,
                    this.props.width, 0]}
                fill='#a05a2c'
                stroke='black'
                strokeWidth={5}
                closed={true}
                opacity={opacity}
            />
            <Circle
                radius={potatoRad}
                fill="yellow"
                x={this.props.width / 2}
                y={potato_y}
                opacity={opacity}
            />
            <Text 
                x={0} 
                y={-height*2} 
                fontSize={this.props.numberSize} 
                text={this.props.nr} 
                fill='black' 
                opacity={opacity}               
                align="center"
                width={this.props.width}           
            />
        </Group>

        );
    }
}


class Bed_rows extends React.Component {


    render() {

        let rowWidth = 600  
        if(rowWidth > this.props.rowDistance){
            rowWidth = this.props.rowDistance
        }
        let totalInterDistance = (this.props.rows - 1) * this.props.rowDistance
        console.log(totalInterDistance)
        let lastX =this.props.width / 2  - (totalInterDistance + rowWidth) / 2 
        return (
            <Group
                x={this.props.x}
                y={this.props.y}            >   
                <Potato_row x={lastX} y={0} width={rowWidth} nr={this.props.nr} onToggle={this.props.onRowToggle} numberSize={this.props.numberSize}/>
                {Array(this.props.rows - 1).fill().map((e, i) => {
                    lastX = lastX + this.props.rowDistance;
                    return <Potato_row numberSize={this.props.numberSize} x={lastX} y={0} width={rowWidth} nr={this.props.nr + i + 1} key={i} onToggle={this.props.onRowToggle}/>
                })}
            </Group>
        );
    }
}


export class Planter extends React.Component {


    state = {
        transparentRows: {}, // keys will be row IDs (e.g. "row-1") with boolean values
        sten_bredde: 100,
        sublayerHeight: 200
      };


      // Toggle transparency for a specific row (identified by rowId)
        handleRowToggle = (rowId, isTransparent) => {
        this.setState((prevState) => {
            const current = prevState.transparentRows[rowId] || false;
            const updated = { ...prevState.transparentRows, [rowId]: isTransparent};

            // Optionally, inform a parent component about the new count:
            if (this.props.onTransparentChange) {
            const transparentCount = Object.values(updated).filter(Boolean).length;
            this.props.onTransparentChange(transparentCount);
            }

            return { transparentRows: updated };
        });
        };
            
      render() {        
       
       
        let totalWidth = this.props.width * Math.ceil(this.props.planterRows / this.props.rowsPrBed)
        let nrOfPlanters = Math.floor(this.props.nrbeds * this.props.width / totalWidth)
        console.log(nrOfPlanters)
        // let TotalbedWidth = this.props.width * bedsPrPlanter
        let lastX = 0//bedsPrPlanter / 2 * this.props.width - totalWidth / 2
        let dirtStart = this.state.sten_bredde
        let dirtEnd = this.props.width - this.state.sten_bredde
        return (
          <Group x={this.props.x} y={this.props.y}>
              {Array(this.props.nrbeds).fill().map((e, i) => {                  
                 return <SubLayer x={this.props.width * i} y={0} width={this.props.width} dirtStart={dirtStart} dirtEnd={dirtEnd} height={this.state.sublayerHeight} key={"a" + i}/>
              })}

                {Array(this.props.nrbeds).fill().map((e, i) => {
                    let rowNumberBase = 1 + i * this.props.rowsPrBed
                    let xbed = lastX +   this.props.width* i                   
                    return (
                        <>
                        <Bed_rows x={xbed} 
                        y={-this.state.sublayerHeight} 
                        numberSize={this.props.numberSize}
                        width={this.props.width} 
                        interRowDistance={this.props.width - (this.props.rowsPrBed - 1) * this.props.rowDistance} 
                        rowDistance={this.props.rowDistance}
                        rows={this.props.rowsPrBed} 
                        key={"b" + i} 
                        nr={rowNumberBase}
                        onRowToggle={this.handleRowToggle}
                        />
                        </>
                    );
                })}
                {Array(nrOfPlanters ).fill().map((e, i) => {
                    let xPlanter = totalWidth * i + this.props.width * this.props.firstRows
                    return (
                        <>
                        <Text x={xPlanter + totalWidth / 2} y={100} fontSize={this.props.numberSize} text={i + 1} fill='black' key={"c" + i}/>
                        <Line
                            points={[xPlanter , 0, xPlanter  , -1000]}
                            stroke='black'
                            strokeWidth={this.props.seperationLineWidth}
                            dash={[50, 50]} key={"d" + i} />
                        </>
                    );
                })}
            </Group>
        );
    }
}